import { Action, Reducer, ActionCreator } from 'redux';
import { AppThunkAction, ApplicationState } from './';
import { sentMessage } from "../signalR/connectedUsers";

export interface MngHubState {
    isConnected: boolean;
    isOpen: boolean;
    hasUnseenMessage: boolean;
    connectedUsers: any;
    connectionId: any;
    messages: any; 
    message: string;
}

interface MngHubConnectionOpened {
    type: "USERHUB_CONNECTION_OPENED",
}

interface MngHubConnectionClosed {
    type: "USERHUB_CONNECTION_CLOSED",
}

interface ReceiveConnectedUsers {
    type: "RECEIVE_CONNECTED_USERS",
    payload: { connectedUsers: any }
}

interface ReceiveConnectionId {
    type: "RECEIVE_CONNECTION_ID",
    payload: { connectionId: any }
}

interface ReceiveNewUserMessage {
    type: "RECEIVE_NEW_USER_MESSAGE",
    payload: { message: any }
}

interface UserHubUpdateMessage {
    type: "USERHUB_UPDATE_MESSAGE",
    payload: { value: string }
}

interface UserHubSendMessage {
    type: "USERHUB_SEND_MESSAGE",
}
interface UserHubUpdateIsOpen {
    type: "USERHUB_UPDATE_ISOPEN";
    payload: { value: boolean }
}

export type KnownAction = MngHubConnectionOpened
    | MngHubConnectionClosed | ReceiveConnectedUsers
    | ReceiveNewUserMessage | UserHubUpdateMessage
    | UserHubSendMessage | UserHubUpdateIsOpen
    | ReceiveConnectionId;

//No need I think
export const actionCreators = {
    updateMessage: (value: string) => <UserHubUpdateMessage>{
        type: "USERHUB_UPDATE_MESSAGE",
        payload: { value: value }
    },
    sendMessage: (): AppThunkAction<KnownAction,any> => (dispatch, getState) => {
        sentMessage(getState().mngHub.message);
        dispatch({ type: "USERHUB_SEND_MESSAGE" });
    },
    updateIsOpen: (value: boolean) => <UserHubUpdateIsOpen>{
        type: "USERHUB_UPDATE_ISOPEN",
        payload: { value: value }
    }
};

const unloadedState: MngHubState = {
    isConnected: false,
    isOpen: false,
    hasUnseenMessage: false,
    connectedUsers: [],
    connectionId: "",
    messages: [],
    message: "",
};

export const reducer: Reducer<MngHubState> = (state: MngHubState, incomingAction: Action) => {
    const action = incomingAction as KnownAction;
    switch (action.type) {
        case "USERHUB_CONNECTION_OPENED":
            return {
                ...state,
                isConnected: true
            };
        case "USERHUB_CONNECTION_CLOSED":
            return {
                ...state,
                isConnected: false
            };
        case "RECEIVE_CONNECTED_USERS":
            return {
                ...state,
                connectedUsers: action.payload.connectedUsers
            };
        case "RECEIVE_CONNECTION_ID":
            return {
                ...state,
                connectionId: action.payload.connectionId
            };
        case "RECEIVE_NEW_USER_MESSAGE":
            return {
                ...state,
                messages: state.messages
                    .concat([action.payload.message]),
                hasUnseenMessage: !state.isOpen
            };
        case "USERHUB_UPDATE_MESSAGE":
            return {
                ...state,
                message: action.payload.value
            };
        case "USERHUB_SEND_MESSAGE":
            return {
                ...state,
                message: ""
            };
        case "USERHUB_UPDATE_ISOPEN":
            return {
                ...state,
                isOpen: action.payload.value,
                hasUnseenMessage: action.payload.value
                    ? false
                    : state.hasUnseenMessage
            };
        default:
            // The following line guarantees that every action in the KnownAction union has been covered by a case above
            const exhaustiveCheck: never = action;
    }

    return state || unloadedState;
};
